import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { appConfig } from '../app.config';
import { Observable } from 'rxjs';
import { AccessPointIdentifiers, CommodityPerimeter } from './models/PurchasingModel';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class purchasingApiService {
  config:any;
  apiUrl: string='';
  constructor(private apiService: CommonService) {
    this.config=appConfig
    this.apiUrl=this.config.PurchasingServiceUrl;
  }
//get material groups homologation NBOP
  getMaterialGroupHomologation(code:any,page:number,pageSize:number):Observable<CommodityPerimeter> {
   //return this.apiService.get(this.config.ApiPurchasingUrl +'commodity-perimeters?code='+code +'&typeCode=Material Group&typeScope=NBOP&status=VALIDATED') as Observable<commodityPerimeter>
    let data = this.apiService.get(`${this.config.ApiPurchasingUrl}commodity-perimeters?code=in(${code.trim()})&typeCode=Material Group&typeScope=NBOP&status=VALIDATED&_page=${page}&_pagesize=${pageSize}`)
    return this.apiService.response(data,CommodityPerimeter,'commodity-perimeters') as Observable<CommodityPerimeter>;
  }

  //get ACP by ID
  getQualifiersById(accessPointIdentifier,identifierTypeName,page=0 ):Observable<AccessPointIdentifiers> {
    let data = this.apiService.get(`${this.config.ApiSitesUrl}access-point-identifiers?identifierTypeName=${identifierTypeName.trim()}&accessPointIdentifier=${accessPointIdentifier.trim()}&_page=${page}`)
    return this.apiService.response(data,AccessPointIdentifiers,'access-point-identifiers') as Observable<AccessPointIdentifiers>;
  }

  getcommodityPerimeters(url):Observable<CommodityPerimeter> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-commodity-perimeters`, url);
    return this.apiService.response(data,CommodityPerimeter,'commodity-perimeters') as Observable<CommodityPerimeter>;
  }
}
